import { SectionTitleBarSwitch } from 'components/SectionTitleBarComponents/SectionTitleBarSwitch'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { isSemiosEmployeeOrTester } from 'utils/isSemiosEmployeeOrTester'

export const getLarvalTrendToggleButton = () => {
  if (!isSemiosEmployeeOrTester()) return undefined

  return <LarvalTrendToggleButton />
}

const LarvalTrendToggleButton = () => {
  const { larvalTrendShowValues } = detailsPanelStore.useSelector((s) => ({
    larvalTrendShowValues: s?.larvalTrendShowValues,
  }))

  return (
    <div>
      <SectionTitleBarSwitch
        checked={larvalTrendShowValues}
        onChange={(event) =>
          detailsPanelStore.setState((s) => ({ ...s, larvalTrendShowValues: event.target.checked }))
        }
        label={
          <span css={{ whiteSpace: 'nowrap', fontWeight: 'normal' }}>
            {translate.phrases.banyanApp('Show Larval Trend Values')}
          </span>
        }
        key="sectionTitleBarSwitch"
      ></SectionTitleBarSwitch>
    </div>
  )
}
